import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpRequestService} from '../../shared/services/http-request.service';
import {environment} from '../../../environments/environment';
import {GridService} from '../../shared/services/grid.service';


@Injectable()
export class CreateGroupService {
  private updateGroupURL = environment.apiUrl + '/VenueCms/UpdateGroup';
  private newGroupURL = environment.apiUrl + '/VenueCms/NewGroup';
  private deleteGroupURL = environment.apiUrl + '/VenueCms/DeleteGroup';
  private getGroupAnalytiscUrl = environment.apiUrl + '/VenueCms/GetGroupAnalytisc';


  constructor(private http: HttpRequestService) {}
  public updateGroup(data) {
    return this.http.post(this.updateGroupURL, data, true);
  }

  public newGroup(data) {
    return this.http.post(this.newGroupURL, data, true);
  }
  public deleteGroup(id) {
    return this.http.get(this.deleteGroupURL + '?id=' + id);
  }

  public getGroupAnalytisc(venueGroupId: number) {
    return this.http.get(this.getGroupAnalytiscUrl + '?venueGroupId=' + venueGroupId);
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/create-group/create-group.service.ts